var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70835 8.74996H3.66669V2.91663H8.70835M8.70835 2.08329H3.66669C3.42357 2.08329 3.19041 2.17109 3.01851 2.32737C2.8466 2.48365 2.75002 2.69561 2.75002 2.91663V8.74996C2.75002 8.97097 2.8466 9.18293 3.01851 9.33922C3.19041 9.4955 3.42357 9.58329 3.66669 9.58329H8.70835C8.95147 9.58329 9.18463 9.4955 9.35653 9.33922C9.52844 9.18293 9.62502 8.97097 9.62502 8.74996V2.91663C9.62502 2.69561 9.52844 2.48365 9.35653 2.32737C9.18463 2.17109 8.95147 2.08329 8.70835 2.08329ZM7.33335 0.416626H1.83335C1.59024 0.416626 1.35708 0.504423 1.18517 0.660704C1.01326 0.816984 0.916687 1.02895 0.916687 1.24996V7.08329H1.83335V1.24996H7.33335V0.416626Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.d2a88c96.svg";
export { ForwardRef as ReactComponent };